import React from "react";
import { VideoPlayer } from "@/components/VideoPlayer";

// Thin wrapper kept for its existing call sites (PostCard / CommentModal /
// CommentThread). All feed video playback now flows through the universal
// <VideoPlayer> (feed mode) — Cloudflare + Bunny HLS, poster, letterbox.
export const FeedVideo = (props) => <VideoPlayer mode="feed" {...props} />;

export default FeedVideo;
